/* eslint no-template-curly-in-string: 0 */
import bestBuyLogo from "../../assets/images/best_buy.svg";
import bestBuyGiftCard from "../../assets/images/best-buy-egift-card.png";
import { FLOW_TYPES, PAYMENT_STATUSES } from "../../utils/enums";

const aboutNetworkFaq = {
  answer: "Best Buy® gift cards make it easy to enjoy all the latest technology. Whether you're looking for smart home devices, drone, or 4K Ultra HD TVs, Associates will help you make the right choice. Plus, Geek Squad® can help keep it all running right with installation, setup, support and repair. Use Best Buy gift cards to get the tech you want and the services you need in stores and at <a href=\"BestBuy.com\">BestBuy.com</a>.<br/><br/>For full Best Buy gift card terms and conditions, visit <a href=\"www.bestbuy.com/gcterms\">www.bestbuy.com/gcterms</a>.",
  question: "About BestBuy® eGiftCard"
};

export const bestBuy = {
  id: "EGIFT_BLACKHAWK_BESTBUY",
  displayName: "Best Buy eGiftCard",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Best Buy eGiftCard™",
      tagline: "Use online or in-store",
      description: [
        {
          string: "Immediate funds to buy electronics and entertainment",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: bestBuyLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Best Buy eGiftCard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    btnLabel: "GET MY BEST BUY CARD",
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Best Buy eGiftCard which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: bestBuyGiftCard
  },
  networkSelectionAccepted: {
    imgSrc: bestBuyGiftCard,
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Best Buy eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Best Buy eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: bestBuyGiftCard,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: bestBuyGiftCard,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default bestBuy;
